import cx from "classnames";

import { ICartItem } from "common/types/carts";
import { toDate } from "common/utils/dates";
import { isValueSet } from "common/utils";

import DoctorImage from "client/common/components/images/DoctorImage";

import styles from "../styles/CartItemPrescriptions.module.less";

type CartItemPrescriptionsProps = { cartItem: ICartItem };

const CartItemPrescriptions = ({ cartItem }: CartItemPrescriptionsProps) => {
  const prescriptions = cartItem.available_prescriptions.map((prescription) => ({
    ...prescription,
    facts: [
      {
        label: "Pet Name",
        value: prescription.patient.name_display,
        className: styles.pet,
      },
      {
        label: "Prescribed on",
        value: toDate(prescription.prescribed_on),
        className: styles.prescribed,
      },
      {
        label: "Expires on",
        value: prescription.expiration_date && toDate(prescription.expiration_date),
      },
      {
        label: "Fills",
        value: prescription.remaining_fills_display,
      },
      {
        label: "Qty per fill",
        value: prescription.quantity_per_fill_display,
      },
    ],
  }));

  if (!cartItem.available_prescriptions.length) {
    return (
      <div className={styles.container}>
        <div className={styles.approval}>
          <DoctorImage className={styles.doctorImage} src={cartItem.primary_doctor.image_url} />
          <div className={styles.text}>
            <p className={styles.label}>Veterinarian approval required</p>
            <p className={styles.description}>
              Your veterinarian will review your medication request. If you aren&apos;t sure of the
              correct size and dose, please contact your veterinarian directly.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.approval}>
        <DoctorImage className={styles.doctorImage} src={cartItem.primary_doctor.image_url} />
        <div className={styles.text}>
          <p className={styles.label}>Prescription on file</p>
          <p className={styles.description}>
            You&apos;re pre-authorized to purchase this medication. If you would like to request a
            different size/strength, place your order and {cartItem.primary_doctor.name_display}{" "}
            will review your request.
          </p>
        </div>
      </div>
      <div className={styles.info}>
        {prescriptions.map((prescription) => (
          <div
            key={prescription.id}
            className={cx(styles.prescription, prescriptions.length > 1 && styles.multi)}
          >
            {prescription.facts.map((fact) => (
              <div key={fact.label} className={cx(styles.fact, fact.className)}>
                <div className={styles.value}>{isValueSet(fact.value) ? fact.value : "-"}</div>
                <div className={styles.label}>{fact.label}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CartItemPrescriptions;
